import React from 'react'
import LoginForm from '../../modules/auth/templete/LoginForm'

const LoginPage =()=> {
  return (
    <>
    <LoginForm/>
    </>
  )
}

export default LoginPage